import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class BlogpostService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allBlogpost(id): Promise<any> {
        return this.httpmanagerService.HttpGet('blogpost', id).then(data => {
            if (data) {
                return data.data;
            }
        })
    }
    sendmail(data): Promise<any> {
        return this.httpmanagerService.HttpPost('blogsubscribe/sendmail', JSON.stringify(data), "").then(data => {
            if (data) {
                return data;
            }
        })
    }
    allBpost(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogpost/allblog', "").then(data => {
            if (data) {
                return data;
            }
        })
    }
    Deactive(blog, id): Promise<any> {
        return this.httpmanagerService.HttpPost('blogpost/deactive', JSON.stringify(blog), id).then(data => {
            if (data) {
                return data;
            }
        })
    }
    Live(blog, id): Promise<any> {
        return this.httpmanagerService.HttpPost('blogpost/live', JSON.stringify(blog), id).then(data => {
            if (data) {
                return data;
            }
        })
    }
    allBlogpost1(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogpost/ablog', "").then(data => {
            if (data) {
                return data;
            }
        })
    }
    iBlogPost(Post): Promise<any> {
        return this.httpmanagerService.HttpPost('blogpost', JSON.stringify(Post), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/blogpost/blogpost.service.ts